import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const ProductExpirationApi = createApi({
  reducerPath: "ProductExpirationReport",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/reports`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProductExpirationReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        return `/product-expiration${query}`;
      },
    }),
    getProductExpirationExport: builder.query({
      async queryFn(params = {}, _queryApi, _extraOptions) {
        const query = buildQuery(params);
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/reports/product-expiration/export${query}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                Accept: "*/*",
              },
            }
          );
          if (!result.ok) {
            return { error: { status: result.status, data: await result.text() } };
          }
          const blob = await result.blob();
          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
  }),
});

export const {
  useLazyGetProductExpirationReportQuery,
  useLazyGetProductExpirationExportQuery,
} = ProductExpirationApi;
